// -------------------------------------------------------------------------------------------------
// Import
// -------------------------------------------------------------------------------------------------

import $ from 'jquery';
import runOnVisible from '../runner-visible';

// -------------------------------------------------------------------------------------------------
// Variables
// -------------------------------------------------------------------------------------------------

const baseClass = 'blog-plugin-container';

// -------------------------------------------------------------------------------------------------
// Classes
// -------------------------------------------------------------------------------------------------

export class BlogAjax {
  constructor(el) {
    this.el = el;
    this.uid = $(el).data('uid');
    this.$noPostsMsg = $(el).find('.blog-no-posts');
    this.$errorMsg = $(el).find('.blog-error');

    runOnVisible(this.el, async () => {
      await this.start();
    });
  }

  async start() {
    this.registerListeners();
    this.preparePagination();
  }

  registerListeners() {
    $(this.el)
      .find('.blog-navigation a')
      .off('click')
      .on('click', this.onClick.bind(this));
  }

  onClick(e) {
    const target = e.currentTarget;
    const ajaxUrl = target.href;
    const tagUid = $(target).data('uid');

    if (ajaxUrl !== undefined && ajaxUrl !== '') {
      e.preventDefault();
      const postsContainer = 'blog-posts-container-' + this.uid;
      const paginationContainer = 'blog-pagination-container-' + this.uid;
      const tagContainer = 'blog-tags-container-' + this.uid;
      const self = this;

      $.ajax({
        url: ajaxUrl,
        type: 'GET',
        beforeSend: function () {
          self.updateTagHighlighting(tagContainer, tagUid);
          $('.animation-container').addClass('blog-posts__fade-out');
          self.$errorMsg.hide();
          self.$noPostsMsg.hide();
        },
        success: function (response) {
          self.updateBlogposts(postsContainer, response)
          self.updatePagination(paginationContainer, response);
        },
        error: function () {
          $('#' + postsContainer).empty();
          $('#' + paginationContainer).empty();
          self.$errorMsg.show();
        },
        complete: function () {
          self.registerListeners();
          $('.animation-container').removeClass('blog-posts__fade-out');
        }
      });
    }
  }

  updateBlogposts(container, response) {
    const $blogpostDom = $(response).find('#' + container);
    if($blogpostDom.length) {
      $blogpostDom.find('img[loading="lazy"]').each(function() {
        $(this)
          .removeAttr('loading')
          .removeClass('lazyload')
          .attr('src', $(this).data('src'));
      })
      $blogpostDom.find('*[class=""]').removeAttr('class');
      $('#' + container).replaceWith($blogpostDom);
    } else {
      $('#' + container).empty();
      this.$noPostsMsg.show();
    }
  }

  updatePagination(container, response) {
    const $paginationDom = $(response).find('#' + container);
    if($paginationDom.length) {
      $('#' + container).replaceWith($paginationDom);
      this.preparePagination();
    }
  }

  preparePagination() {
    $('#blog-pagination-container-' + this.uid + ' a').attr('data-uid', 'pagination');
  }

  updateTagHighlighting(container, uid) {
    const $tagContainer = $('#' + container);
    if (uid === 'pagination') return;
    $tagContainer.find('button.btn.btn-primary').removeClass('btn-primary');
    if(uid !== undefined) {
      $tagContainer.find('a[data-uid="' + uid + '"] > button').addClass('btn-primary');
    } else {
      $tagContainer.find('a:not([data-uid]) > button').addClass('btn-primary');
    }
  }
}

// -------------------------------------------------------------------------------------------------
// Methods
// -------------------------------------------------------------------------------------------------

function init() {
  $(`.${baseClass}`).each((i, el) => new BlogAjax(el));
}


// -------------------------------------------------------------------------------------------------
// Export
// -------------------------------------------------------------------------------------------------

export default {
  init
};
